import React from "react";
import "./CustomFormModal.scss";
import { Modal } from "./Modal";

export interface CustomFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  title: string;
  submitButtonText: string;
  children: React.ReactNode;
  isLoading?: boolean;
  error?: string | null;
  submitButtonClassName?: string;
  isSubmitDisabled?: boolean;
}

const CustomFormModal: React.FC<CustomFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  submitButtonText,
  children,
  isLoading = false,
  error = null,
  submitButtonClassName = "",
  isSubmitDisabled = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="custom-form-modal"
      showCloseButton={false}
    >
      <div className="custom-form-modal__header">
        <h3 className="custom-form-modal__title">{title}</h3>
        <button
          className="custom-form-modal__close-btn"
          onClick={onClose}
          aria-label="Close"
          type="button"
        >
          <i className="f-icon xmark-icon fa-solid"></i>
        </button>
      </div>

      <form onSubmit={onSubmit} className="custom-form-modal__form">
        {error && <div className="custom-form-modal__error">{error}</div>}

        <div className="custom-form-modal__fields">{children}</div>

        <div className="custom-form-modal__footer">
          <button
            type="submit"
            className={`custom-form-modal__submit-btn ${submitButtonClassName} ${isSubmitDisabled ? 'disabled' : ''}`}
            disabled={isLoading || isSubmitDisabled}
          >
            {submitButtonText}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CustomFormModal;
